"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
function ToggleGroup({ children }) {
    return ((0, preact_1.h)("div", { className: 'flex' }, children));
}
exports.default = ToggleGroup;
ToggleGroup.Input = Input;
ToggleGroup.Label = Label;
function Input({ children }) {
    return ((0, preact_1.h)("span", { className: 'flex-shrink-0' }, children));
}
function Label(props) {
    return (0, preact_1.h)("label", Object.assign({ className: 'flex-1 max-w-max pl-2.5 sm:pl-3' }, props));
}
